import { useQuery } from '@apollo/client'
import { Button } from '@material-ui/core'
import React from 'react'
import { toast } from 'react-toastify'

import { CREDITORS_BRIEF_QUERY } from '../../../graphql/walletCreditors'
import { CreditorEntityRef } from '../../../helpers/creditorEntities'
import { getTranslate } from '../../../localization'
import { Currency } from '../../../types/currency'
import { AddCreditorsRequestInput } from '../../../types/walletCreditor'
import CreditorDetailsSection from './creditorDetailsSection'
import useStyles from './styles/stepTwoCreditorsDetails.styles'

interface StepTwoCreditorsDetailsProps {
  creditorsInput: AddCreditorsRequestInput
  setcreditorsInput: React.Dispatch<
    React.SetStateAction<AddCreditorsRequestInput>
  >
  currency: Currency
}

const StepTwoCreditorsDetails: React.FC<StepTwoCreditorsDetailsProps> = ({
  creditorsInput,
  setcreditorsInput,
  currency
}) => {
  const classes = useStyles()
  const { data } = useQuery<{ creditorsBrief: CreditorEntityRef[] }>(
    CREDITORS_BRIEF_QUERY,
    {
      variables: { walletID: creditorsInput.walletID },
      skip: !creditorsInput.walletID,
      fetchPolicy: 'network-only',
      onError: (err) => toast.error(err.message)
    }
  )

  // Function to handle adding a new creditor
  const addCreditor = () => {
    setcreditorsInput((prev) => ({
      ...prev,
      creditors: [
        ...prev.creditors,
        {
          entity: { entityType: '', entityID: '' },
          maxCredit: 0,
          maxReservable: 0,
          active: true,
          canUseCredit: true,
          autoSettelmentEnabled: true,
          paymentTermAssignment: []
        }
      ]
    }))
  }

  return (
    <div className={classes.container}>
      {creditorsInput.creditors.map((creditor, index) => (
        <CreditorDetailsSection
          creditor={creditor}
          key={index}
          creditorsInput={creditorsInput}
          currency={currency}
          index={index}
          setcreditorsInput={setcreditorsInput}
          existingCreditors={data?.creditorsBrief || []}
        />
      ))}

      {/* Add More Creditor Button */}
      <Button
        className={classes.addCreditorButton}
        color="primary"
        onClick={addCreditor}
        startIcon={<span className={classes.addIcon}>+</span>}>
        {getTranslate('Add More Creditor')}
      </Button>
    </div>
  )
}

export default StepTwoCreditorsDetails
